import { RouteObject } from 'react-router-dom';

import JSMailDetail from 'Components/jobseekersSide/JSMailDetail';

import { JSAddAlert } from './feature-alert-add-edit';
import { JSAppliedJobs } from './feature-applied-jobs-browser';
import { JSChangePassword } from './feature-change-password';
import { CreateResumeMode, FeatureCreateResume, ResumeHeader } from './feature-create-resume';
import { CandidateAppliedView } from './feature-job-applied-view';
import { JSMailHistory } from './feature-mailing-history';
import { FeatureManageAlerts } from './feature-manage-alerts';
import { FeatureManageCvs } from './feature-manage-cv';
import { FeatureSavedJobs } from './feature-saved-jobs';
import { FeatureUserProfile } from './feature-user-profile';
import { JSMyCV } from './feature-browse-cv';
import { Flex } from '@radix-ui/themes';


const CreateResumeRoute = () => (
   <Flex direction="column" flexGrow="1">
      <ResumeHeader mode={CreateResumeMode.CREATE} />
      <FeatureCreateResume mode={CreateResumeMode.CREATE} />
   </Flex>
);

const EditResumeRoute = () => (
   <Flex direction="column" flexGrow="1">
      <ResumeHeader mode={CreateResumeMode.EDIT} />
      <FeatureCreateResume mode={CreateResumeMode.EDIT} />
   </Flex>
);

const CopyResumeRoute = () => (
   <Flex direction="column" flexGrow="1">
      <ResumeHeader mode={CreateResumeMode.COPY} />
      <FeatureCreateResume mode={CreateResumeMode.COPY} />
   </Flex>
);

export const CANDIDATE_ROUTES: RouteObject[] = [
   {
      path: '/alerts/index',
      Component: FeatureManageAlerts,
   },
   {
      path: '/alerts/add',
      Component: JSAddAlert,
   },
   {
      path: '/alerts/edit/:slug',
      Component: JSAddAlert,
   },
   {
      path: '/candidate/my-cv-list/:id',
      Component: JSMyCV,
   },
   {
      path: '/candidate/create-resume',
      Component: CreateResumeRoute,
   },
   {
      path: '/candidate/my-cv-list',
      Component: FeatureManageCvs,
   },
   {
      path: '/candidate/saved-jobs',
      Component: FeatureSavedJobs,
   },
   {
      path: '/candidate/applied-jobs',
      Component: JSAppliedJobs,
   },
   {
      path: '/candidate/mailing-history',
      Component: JSMailHistory,
   },
   {
      path: '/candidates/job-applied-view/:id',
      Component: CandidateAppliedView,
   },
   {
      path: '/candidate/profile',
      Component: FeatureUserProfile,
   },
   {
      path: '/candidate/change-password',
      Component: JSChangePassword,
   },
   {
      path: '/candidates/maildetail/:slug',
      Component: JSMailDetail,
   },

   /**
    *  CV Create-Edit-Copy
    */
   {
      path: '/candidate/resume/create',
      Component: CreateResumeRoute,
   },
   {
      path: '/candidate/resume/:id/edit',
      Component: EditResumeRoute,
   },
   {
      path: '/candidate/resume/:id/copy',
      Component: CopyResumeRoute,
   },
];
